import { render, staticRenderFns } from "./ContracteProductie.vue?vue&type=template&id=5e5e4530"
import script from "./ContracteProductie.vue?vue&type=script&lang=js"
export * from "./ContracteProductie.vue?vue&type=script&lang=js"
import style0 from "./ContracteProductie.vue?vue&type=style&index=0&id=5e5e4530&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports